
export default { name: "setting-black" };
